<template>
    <div
        :class="{
            'form-container': !dashboard,
            'form-container-slider': dashboard
        }"
    >
        <div v-if="dashboard" class="form-container-slider-header">
            <a class="close" @click="close">
                <font-awesome-icon :icon="['fal', 'times']" />
            </a>
        </div>
        <div :class="{ success: !dashboard }" v-if="payment">
            <FormHeading v-if="!dashboard">{{
                propertyValueOverLimit
                    ? "Sent to Underwriter for Review"
                    : "Success"
            }}</FormHeading>
            <template v-if="propertyValueOverLimit && !dashboard">
                <P
                    >Thank you for submitting your request for Dremca insurance.
                    Our team will review and respond within 24 business
                    hours.</P
                >
            </template>
            <template v-else>
                <P v-if="!dashboard"
                    >Your transaction has been processed securely.</P
                >
                <P v-if="!dashboard">
                    A detailed summary of your purchase is below. An email will
                    be sent to
                    <span class="email">{{ owner.email }}</span> or you can
                    download it below.
                </P>
            </template>
            <div
                v-if="dashboard && startEdit"
                class="row-group row-group-number"
            >
                <div class="policy-input">
                    <TextInput
                        v-model="policyNumber"
                        name="policyNumber"
                        label="Policy Number"
                        type="text"
                    />
                </div>
                <Button class="transparent" @click="cancel">Cancel</Button>
                <Button class="redOutline" @click="onSave">Save</Button>
            </div>
            <div v-if="dashboard && !startEdit" class="row-group">
                <h3>Policy Number</h3>
                <P class="purchase-details">
                    <a class="edit" @click="startEditing">
                        <span
                            v-if="payment.policy_number"
                            class="policy-number"
                            >{{ payment.policy_number }}</span
                        >
                        <font-awesome-icon
                            class="caret"
                            :icon="['fal', 'pen']"
                        />
                    </a>
                </P>
            </div>
            <div v-if="payment.reference_number" class="row-group">
                <h3>Reference Number</h3>
                <P class="purchase-details">{{ payment.reference_number }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Insured Name</h3>
                <h3 class="owner-name">{{ owner.name }}</h3>
            </div>
            <div v-if="dashboard && owner.is_commercial == 1" class="row-group">
                <h3>Company Contact</h3>
                <P class="purchase-details">{{
                    owner.contact_first_name + " " + owner.contact_last_name
                }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Insured Email Address</h3>
                <a
                    class="purchase-details owner-email"
                    :href="`mailto:${owner.email}`"
                    >{{ owner.email }}</a
                >
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Insured Phone Number</h3>
                <P class="purchase-details">{{ owner.phone }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Insured Mailing Address</h3>
                <P class="purchase-details">{{ owner.address }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Insured NAICS Code</h3>
                <P class="purchase-details">{{ owner.naic_code }}</P>
            </div>
            <template v-if="!propertyValueOverLimit">
                <div class="row-group">
                    <h3>Date of Purchase</h3>
                    <P class="purchase-details">{{ payment.created_at }}</P>
                </div>
            </template>
            <div class="row-group">
                <h3>
                    {{ propertyValueOverLimit ? "Requested " : "" }}Policy
                    Effective Date
                </h3>
                <P class="purchase-details">{{
                    payment.policy_effective_date
                }}</P>
            </div>
            <div class="row-group">
                <h3>
                    {{ propertyValueOverLimit ? "Requested " : "" }}Policy
                    Expiration Date
                </h3>
                <P class="purchase-details">{{
                    payment.policy_expiration_date
                }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Tax State</h3>
                <P class="purchase-details">{{
                    payment.tax_state
                }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>TRIA</h3>
                <P v-if="!propertyValueOverLimit" class="purchase-details">{{
                    payment.avail_tria == 1 ? "Accept" : "Reject"
                }}</P>
            </div>

            <div v-if="payment.billing" class="row-group">
                <h3>Billing Name</h3>
                <P class="purchase-details">{{ payment.billing.name }}</P>
            </div>
            <div v-if="payment.billing" class="row-group">
                <h3>Billing Email</h3>
                <P class="purchase-details">{{ payment.billing.email }}</P>
            </div>
            <div v-if="payment.billing" class="row-group">
                <h3>Billing Phone</h3>
                <P class="purchase-details">{{ payment.billing.phone }}</P>
            </div>
            <div v-if="payment.billing" class="row-group">
                <h3>Billing Address</h3>
                <P class="purchase-details">{{ payment.billing.address }}</P>
            </div>
            <div class="row-group" v-if="validBankRouting">
                <h3>Routing Number</h3>
                <P class="purchase-details">{{
                    payment.bank_routing_number
                }}</P>
            </div>
            <div class="row-group" v-if="validBankAccount">
                <h3>Account Number</h3>
                <P class="purchase-details">{{
                    payment.bank_account_number
                }}</P>
            </div>
            <div v-if="!dashboard" class="row-group">
                <h3>Bank Name</h3>
                <P class="purchase-details">{{ payment.bank_name }}</P>
            </div>
            <div class="row-group" v-if="!dashboard">
                <h3>Account Number</h3>
                <P class="purchase-details">{{
                    payment.customer_bank_account_number
                }}</P>
            </div>
            <div class="row-group">
                <h3>Account Type</h3>
                <P class="purchase-details">{{ payment.account_type }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Due Date</h3>
                <P class="purchase-details">{{
                    payment.payments_withdrawn == "1"
                        ? "1st of the Month"
                        : "15th of the Month"
                }}</P>
            </div>
            <div v-if="dashboard" class="row-group">
                <h3>Payment Option</h3>
                <P class="purchase-details">{{
                    payment.payment_terms == "monthly"
                        ? "12-pay"
                        : "Pay in Full"
                }}</P>
            </div>

            <div class="summary-container">
                <div class="table-wrapper">
                    <div class="table-header">
                        <h3 class="column-heading">Covered Property</h3>
                        <h3 class="column-heading right-align">
                            Limit of Insurance
                        </h3>
                    </div>
                    <div
                        class="table-row"
                        v-for="(property, index) in properties"
                        :key="index"
                    >
                        <div class="cell">
                            <div class="row-label">
                                <span v-if="property.year">{{
                                    property.year
                                }}</span>
                                <span>{{ property.description }}</span>
                                <div class="row-bottom">
                                    <p v-if="property.serial_number">
                                        {{ property.serial_number }}
                                    </p>
                                </div>
                            </div>
                            <template v-if="property.lien">
                                <div class="lien-info">
                                    <p class="heading">
                                        Lienholder:
                                        <span class="details">{{
                                            property.lien.lien_name +
                                                " - " +
                                                property.lien.complete_address
                                        }}</span>
                                    </p>
                                </div>
                            </template>
                        </div>
                        <div class="cell">
                            <p class="row-label right-align">
                                ${{ addComma(property.value) }}
                            </p>
                        </div>
                    </div>

                    <div class="table-footer">
                        <div class="cell">
                            <p class="row-label total-text">
                                Total Property Limit of Insurance
                            </p>
                        </div>
                        <div class="cell">
                            <p class="row-label total right-align">
                                ${{ addComma(payment.total_value) }}
                            </p>
                        </div>
                        <template v-if="!propertyValueOverLimit">
                            <div class="cell">
                                <p class="row-label total-text">Deductible</p>
                            </div>
                            <div class="cell">
                                <p class="row-label total right-align">
                                    ${{ addComma(payment.deductible_amount) }}
                                </p>
                            </div>
                        </template>
                    </div>
                    <template v-if="!propertyValueOverLimit">
                        <div class="table-header">
                            <h3 class="column-heading">Premium</h3>
                            <h3 class="column-heading right-align">Amount</h3>
                        </div>
                        <div class="table-row">
                            <div class="cell">
                                <p class="row-label">
                                    Premium for Covered Property
                                </p>
                            </div>
                            <div class="cell">
                                <p class="row-label right-align">
                                    ${{ addComma(payment.premium_amount) }}
                                </p>
                            </div>
                        </div>
                        <div class="table-row" v-if="payment.avail_tria">
                            <div class="cell">
                                <p class="row-label">Premium for TRIA</p>
                            </div>
                            <div class="cell">
                                <p class="row-label right-align">
                                    ${{ addComma(payment.tria_premium) }}
                                </p>
                            </div>
                        </div>

                        <div class="table-footer">
                            <div class="cell">
                                <p class="row-label total-text">
                                    Total Annual Premium
                                </p>
                            </div>
                            <div class="cell">
                                <p
                                    class="row-label total right-align"
                                    v-if="payment.avail_tria"
                                >
                                    ${{ round(annualPremium) }}
                                </p>
                                <p class="row-label total right-align" v-else>
                                    ${{
                                        addComma(
                                            payment.total_annual_premium.toString()
                                        )
                                    }}
                                </p>
                            </div>
                        </div>
                    </template>
                </div>
                <P class="underwriter-text" v-if="!dashboard"
                    >Underwritten by Acadia Insurance</P
                >
                <div class="button-group" v-if="!dashboard">
                    <Button class="red" @click="download" style="float: right"
                        >Download
                        {{ propertyValueOverLimit ? "Requested " : "" }}Purchase
                        Summary</Button
                    >
                    <Button
                        class="transparent"
                        @click="downloadReceipt"
                        v-if="!propertyValueOverLimit"
                        >Download Receipt of Insurance</Button
                    >
                    <Button class="transparent" @click="printPage"
                        >Print Page</Button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FormHeading, P, Button, TextInput } from "../../style";
import { mapActions, mapState, mapMutations } from "vuex";
import {
  FETCH_DOWNLOAD_URL,
  SET_PAYMENT,
  FETCH_INSURANCE_RECEIPT_DOWNLOAD_URL
} from "../../store/types";
import { addCommaToNumber, scrollTop } from "../../utils";
export default {
  name: "Success",
  props: {
    dashboard: {
      type: Boolean,
      default: false
    },
    underwriting: {
      type: Object,
      default: null
    },
    startEdit: {
      type: Boolean,
      default: false
    },
    save: {
      type: Function
    }
  },
  components: {
    FormHeading,
    P,
    Button,
    TextInput
  },
  computed: {
    ...mapState({
      payment: state => state.equipment.payment
    }),
    owner() {
      const { equipment_owner } = this.payment;
      return equipment_owner;
    },
    properties() {
      const { equipment } = this.payment;
      return equipment;
    },
    annualPremium() {
      return this.addComma(
        parseFloat(this.payment.premium_amount) +
                    parseFloat(this.payment.tria_premium)
      );
    },
    validBankAccount() {
      return (
        this.dashboard &&
                this.payment.bank_account_number &&
                !this.payment.has_policy_number
      );
    },
    validBankRouting() {
      return (
        this.dashboard &&
                this.payment.bank_routing_number &&
                !this.payment.has_policy_number
      );
    },
    propertyValueOverLimit() {
      return this.payment.total_value > 100000 ? true : false;
    }
  },
  created() {
    if (!this.dashboard) {
      const { payment } = this.$store.state.equipment;
      if (!payment) {
        this.$router.push("/get-quote");
      }
    }
  },
  mounted() {
    scrollTop();
  },
  data() {
    return {
      policyNumber: ""
    };
  },
  methods: {
    ...mapActions({
      fetchUrl: FETCH_DOWNLOAD_URL,
      fetchInsuranceReceiptUrl: FETCH_INSURANCE_RECEIPT_DOWNLOAD_URL
    }),
    ...mapMutations({
      setPayment: SET_PAYMENT
    }),
    download() {
      this.fetchUrl({
        id: this.payment.uuid
      })
        .then(({ data }) => {
          window.open(data, "_blank");
        })
        .catch(() => {});
    },
    downloadReceipt() {
      this.fetchInsuranceReceiptUrl({
        id: this.payment.uuid
      })
        .then(({ data }) => {
          window.open(data, "_blank");
        })
        .catch(() => {});
    },
    printPage() {
      window.print();
    },
    addComma(price) {
      return addCommaToNumber(price);
    },
    close() {
      this.refreshPolicyNumber();
      this.cancel();
      this.$emit("close");
    },
    onSave() {
      if (this.policyNumber && this.policyNumber.length) {
        if (this.payment.has_policy_number) {
          this.save(this.payment, this.policyNumber);
        } else {
          this.$confirm(
            `Adding a Policy Number will purge the customer’s Bank Routing Number and Account Number. 
            Do you want to continue?`,
            "",
            {
              confirmButtonText: "Continue",
              cancelButtonText: "Cancel",
              customClass: "alert-update",
              dangerouslyUseHTMLString: true,
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  this.save(this.payment, this.policyNumber);
                  done();
                } else {
                  done();
                }
              }
            }
          )
            .then(() => {})
            .catch(() => {});
        }
      }
    },
    cancel() {
      this.refreshPolicyNumber();
      this.$emit("cancel-policy-edit");
    },
    startEditing() {
      this.$emit("start-policy-edit");
    },
    refreshPolicyNumber() {
      const { policy_number } = this.payment;
      if (!policy_number || !policy_number.length) {
        this.policyNumber = "";
      }
    },
    round(price) {
      return Math.round(price);
    }
  },
  watch: {
    payment: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.policyNumber = newVal.policy_number;
      }
    },
    underwriting: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.dashboard) {
          this.setPayment({
            payment: newVal
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.form-container-slider {
    box-sizing: border-box;
    padding: $padding-xl;
    padding-bottom: 3.875rem;
    &-header {
        display: flex;
        justify-content: flex-end;
        height: $font-size-xxl;
    }
    .close {
        cursor: pointer;
        color: $label-gray;
        font-size: $font-size-md;
        z-index: 5;
        position: fixed;
        width: $font-size-xxl;
    }
    .policy-number {
        margin-right: $padding-md;
    }
    .edit {
        cursor: pointer;
        padding-left: $padding-md;
        padding-right: $padding-md;
        margin-left: (-$padding-md);
    }
    .close,
    .edit {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: $border-radius-md;
        transition: $transition-simple-fast;
        height: $font-size-xxl;
        background-color: $white;
        &:hover {
            background-color: $background-dark;
            color: $blue-navy;
        }
    }
    .row-group-number {
        margin-top: auto;
        .policy-input {
            width: 75%;
        }
        .form-group {
            margin-bottom: auto;
        }
        button {
            display: flex;
            align-items: center;
            margin-left: $padding-lg;
            flex: auto;
            justify-content: center;
        }
    }
    .row-group {
        margin: $padding-xl 0;
        h3 {
            width: 200px;
        }
        p {
            width: 50%;
        }
        h3,
        p {
            font-size: $font-size-sm;
        }
        .owner-email {
            cursor: pointer;
            text-decoration: underline;
            color: $body-gray;
            transition: $transition-simple-fast;
            &:hover {
                color: $blue-navy;
            }
        }
        .owner-name {
            font-weight: 600;
            color: $dark-gray;
        }
        .ip {
            word-break: break-word;
        }
    }
    .summary-container {
        padding-top: 0;
        h2 {
            font-size: $font-size-md;
        }
    }
    .table-wrapper {
        h3,
        p {
            font-size: $font-size-sm;
        }
    }
    .table-footer {
        .total-text {
            text-align: left;
        }
    }
    .table-header,
    .table-footer {
        grid-template-columns: auto 50%;
    }
}
.success {
    text-align: left;
    box-sizing: border-box;
    width: 100%;
    max-width: 750px;
    margin: auto;
    padding: $padding-xxl $padding-lg;
    border-radius: 5px;
    border: 1px solid $background-gray;
    background: $white;
    overflow: hidden;
    position: relative;
    h2 {
        margin-top: 0;
    }
    @include breakpoint(mobile-hd-width) {
        padding: $padding-xxl;
    }
}
.email {
    color: $blue-navy;
    font-weight: bold;
}
h3 {
    color: $demphasis;
    font-size: $font-size-md;
    font-weight: 400;
    width: 240px;
    padding: 0;
    &.column-heading {
        padding: $padding-lg;
        margin: 0;
        width: initial;
    }
}
.row-group {
    vertical-align: top;
    display: flex;
    margin: $padding-xxl 0;
    h3 {
        min-width: 240px;
    }
}
.purchase-details {
    margin: 0;
    display: inline-flex;
    align-items: center;
    span + .edit {
        margin-left: $padding-md;
    }
}
.signature {
    font-family: "Dancing Script", cursive !important;
}
.summary-container {
    border-top: 1px solid #294154;
    padding-top: 2rem;
    .row-bottom {
        p {
            display: inline-block;
            font-size: $font-size-xs;
            color: $label-gray;
            margin: 0;
        }
    }
}
.underwriter-text {
    color: $label-gray;
    font-size: $font-size-sm;
}
.button-group {
    margin-top: 4rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    button {
        margin-bottom: $padding-lg;
    }
    button:last-of-type {
        margin-bottom: 0;
    }
}
</style>
